export default class HeroVideo {

  static init() {
    if(document.querySelectorAll('.ec-b-hero-video__word-carousel--active')) {
      this.initHeroVideo();
    }
  }

  /**
   *
   */
  static initHeroVideo()
  {
    setInterval(() => {
      document.querySelectorAll('.ec-b-hero-video__word-carousel--active').forEach(word => {
        if(word.classList.contains('ec-b-hero-video__word-carousel--active')) {
          word.classList.remove('ec-b-hero-video__word-carousel--active');
          if(word.nextElementSibling == null) {
            word.parentElement.firstElementChild.classList.add('ec-b-hero-video__word-carousel--active');
          } else {
            word.nextElementSibling.classList.add('ec-b-hero-video__word-carousel--active')
          }
        }
      })
    }, 3000);
  }

}
